import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './contact/HeroSection';
import { ContactForm } from './contact/ContactForm';
import { ContactInfoSection } from './contact/ContactInfoSection';
export function ContactPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-383">
      <Navbar data-id="element-384" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-385">
        <HeroSection data-id="element-386" />
        <section className="py-16 md:py-24 bg-brand-black" data-id="element-387">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-388">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16" data-id="element-389">
              <ContactForm data-id="element-390" />
              <ContactInfoSection data-id="element-391" />
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-392" />
    </div>;
}